import { createSlice } from '@reduxjs/toolkit';
import { fetchStarredCandidates, fetchStarredTagsOptions } from '../actions';
import { dedupeOptions } from 'util/helpers';

const initialState = {
  isLoading: true,
  page: 1,
  candidatesCount: 0,
  candidates: [],
  tagsOptions: [],
  tagsOptionsPage: 1,
  tagsOptionsCount: 0,
  isTagsOptionsLoading: true,
};

const starredCandidateSlice = createSlice({
  name: 'candidate',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(fetchStarredCandidates.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchStarredCandidates.fulfilled, (state, action) => {
      const { paging = {} } = action.payload;
      state.candidates = action.payload.candidates || [];
      state.isLoading = false;
      state.page = paging.page;
      state.candidatesCount = paging.items;
    });

    builder.addCase(fetchStarredCandidates.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchStarredTagsOptions.pending, (state) => {
      state.isTagsOptionsLoading = true;
    });

    builder.addCase(fetchStarredTagsOptions.fulfilled, (state, action) => {
      const { paging = {}, tags } = action.payload;

      state.tagsOptions = dedupeOptions(state.tagsOptions, tags);
      state.isTagsOptionsLoading = false;
      state.tagsOptionsPage = paging.page;
      state.tagsOptionsCount = paging.items || state.tagsOptions.length;
    });

    builder.addCase(fetchStarredTagsOptions.rejected, (state, action) => {
      state.isTagsOptionsLoading = false;
      state.tagsError = action.payload.error;
    });
  },
});

export default starredCandidateSlice;
